import { fetchJson } from '../../api/fetchJson'
import { orgPath } from '../../config/orgId'

type PresignResponse = {
  success: true
  data: {
    upload_url: string
    photo_id: string
    key: string
    expires_at: number
    content_type: string
  }
}

export type UploadedPhoto = {
  photo_id: string
  r2_key: string
  filename: string
  content_type: string
  size_bytes: number
}

const ALLOWED = /^image\/(jpeg|png|webp|heic)$/

export async function uploadPhotoToR2(
  file: File,
  opts: { projectId?: string; phaseTag?: string },
): Promise<UploadedPhoto> {
  if (!ALLOWED.test(file.type)) {
    throw new Error(`Unsupported type: ${file.type || 'unknown'}`)
  }
  if (file.size > 10 * 1024 * 1024) {
    throw new Error('File exceeds 10MB limit.')
  }

  const presign = await fetchJson<PresignResponse>(orgPath('/photos/upload-url'), {
    method: 'POST',
    body: JSON.stringify({
      upload_type: 'photo',
      project_id: opts.projectId,
      phase_tag: opts.phaseTag,
      content_type: file.type,
      file_size: file.size,
    }),
  })

  const put = await fetch(presign.data.upload_url, {
    method: 'PUT',
    headers: { 'Content-Type': presign.data.content_type },
    body: file,
  })
  if (!put.ok) throw new Error(`R2 upload failed: ${put.status}`)

  return {
    photo_id: presign.data.photo_id,
    r2_key: presign.data.key,
    filename: file.name,
    content_type: file.type,
    size_bytes: file.size,
  }
}

export async function savePhotoMetadata(input: {
  photo: UploadedPhoto
  projectId: string
  caption?: string
}) {
  return fetchJson(orgPath('/photos'), {
    method: 'POST',
    body: JSON.stringify({
      photo_id: input.photo.photo_id,
      project_id: input.projectId,
      r2_key: input.photo.r2_key,
      filename: input.photo.filename,
      content_type: input.photo.content_type,
      size_bytes: input.photo.size_bytes,
      caption: input.caption || null,
    }),
  })
}
